<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="article.id === null">{{ 'ARTICLE.NEWARTICLE' | translate }}</span>
            <span *ngIf="article.id !== null">{{ 'ARTICLE.EDITARTICLE' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="articleForm" id="articleForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="articleForm" >
            <input type="hidden" name="id" id="articleId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-newspaper"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="category" [autoDisplayFirst]="false" formControlName="category" [options]="categories" (onChange)="onChange($event)" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="category" class="req">{{ 'CATEGORY.CATEGORY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="articleForm.controls['category'].invalid && (articleForm.controls['category'].dirty || articleForm.controls['category'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="articleForm.controls['category'].errors !== null">
                  <div *ngIf="articleForm.controls['category'].errors.required">
                   {{ 'ARTICLE.ARTICLETYPEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="articleTitle" formControlName="title" type="text" pInputText [required]="false"> 
                      <label for="articleTitle" class="">{{ 'TITLE' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="articleTitleEn" formControlName="TitleEn" type="text" pInputText [required]="false"> 
                      <label for="articleTitleEn" class="">{{ 'TitleEn' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="articleTitleFr" formControlName="titleFr" type="text" pInputText [required]="false"> 
                      <label for="articleTitleFr" class="">{{ 'TITLEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            
            <div class="p-fluid p-grid">
              
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>


                    <input type="file"  formControlName="imagePath" description="imagePath" pButton pRipple icon="pi pi-folder" styleClass="p-button-info"  class="w-100" (change)="uploadPhoto($event)" accept="image/*" />
                  </div>
                </div>

              </div><!--/p-col-6-->

            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                  <label for="description" class="req">{{ 'DESCRIPTION' | translate }}</label>
                  <ckeditor  inputId="description" formControlName="description"  [editor]="Editor" [config]="editorService.config" type="content"  [required]="true" ></ckeditor>
                </div>
                <div *ngIf="articleForm.controls['description'].invalid && (articleForm.controls['description'].dirty || articleForm.controls['description'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="articleForm.controls['description'].errors !== null">
                  <div *ngIf="articleForm.controls['description'].errors.required">
                   {{ 'DESCRIPTION' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-12">

                <div class="p-field p-col-12">
                      <label for="descriptionFr" class="req">{{ 'DESCRIPTIONFR' | translate }}</label>
                      <ckeditor  inputId="descriptionFr" formControlName="descriptionFr"  [editor]="Editor" [config]="editorService.config" type="content"  [required]="true" ></ckeditor>
                </div>
                <div *ngIf="articleForm.controls['descriptionFr'].invalid && (articleForm.controls['descriptionFr'].dirty || articleForm.controls['descriptionFr'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="articleForm.controls['descriptionFr'].errors !== null">
                  <div *ngIf="articleForm.controls['descriptionFr'].errors.required">
                   {{ 'DESCRIPTIONFR' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
          
            <div class="p-fluid p-grid">

            <div class="p-col-12">

              <div class="p-field p-col-12">
                <div class="p-field p-col-12">
                  <label for="DescriptionEn" class="req">{{ 'DescriptionEn' | translate }}</label>
                  <ckeditor  inputId="DescriptionEn" formControlName="DescriptionEn"  [editor]="Editor" [config]="editorService.config" type="content"  [required]="true" ></ckeditor>
            </div>
              </div>
              <div *ngIf="articleForm.controls['DescriptionEn'].invalid && (articleForm.controls['DescriptionEn'].dirty || articleForm.controls['DescriptionEn'].touched)" class="alert alert-danger">
                <ng-container *ngIf="articleForm.controls['DescriptionEn'].errors !== null">
                <div *ngIf="articleForm.controls['DescriptionEn'].errors.required">
                 {{ 'DescriptionEn' | translate }}.
                </div>
                </ng-container>
              </div>

            </div><!--/p-col-6-->
            
            </div>

            <div class="p-fluid p-grid">

              <div class="p-col-12">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!postForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'ACTIONS.SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

